// @flow
import * as React from 'react';
import styles from './FixedScrollContainer.module.scss';

const FixedScrollContainer = ({ children }) => {
  const [hidden, setHidden] = React.useState(false);

  React.useEffect(() => {
    function handleScroll() {
      if (!hidden) {
        setHidden(window.scrollY > 2000);
      }
    }

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hidden]);

  return (
    <div className={`${styles['container']} ${hidden ? styles['hidden'] : ''}`}>
      {children}
    </div>
  );
};

export default FixedScrollContainer;
